export default "__VITE_ASSET__CI38Y3sy__"